import {HistoryEvent} from "./HistoryEvent";
import {WordEntry} from "./WordEntry";
import {HistoryStats} from "./HistoryStats";

export class WordOracle {
    public static nextWord(history: HistoryEvent[],
                           knownWords: WordEntry[],
                           knownCharacters: string,
                           minWordOptions: number,
                           recentsToSkip: number): WordEntry {
        let orderedChars = this.orderCharacters(knownCharacters, history);
        let wordsToSkip = history.sort((lhs, rhs) => lhs.index > rhs.index ? 1 : -1).slice(history.length - recentsToSkip, history.length + 1);
        let wordOptions = this.nextWordOptionsForMultipleCharacter(
            orderedChars, knownWords, minWordOptions, wordsToSkip
        );
        return this.chooseFromOptions(wordOptions);
    }

    private static chooseFromOptions(wordOptions: WordEntry[]) {
        return this.randomFrom(wordOptions);
    }

    public static orderCharacters(knownCharacters: string, history: HistoryEvent[]) {
        const stats = new HistoryStats().lowestConsecutiveCorrect(knownCharacters, history);
        let orderedChars = stats.reduce((agg: string[], current: [string[], number]) => {
            return agg.concat(current[0]);
        }, []);
        return orderedChars;
    }

    private static nextWordOptionsForMultipleCharacter(
        orderedChars: string[],
        knownWords: WordEntry[],
        minWordOptions: number,
        wordsToSkip: HistoryEvent[]): WordEntry[] {
        let readingsToSkip: string[] = wordsToSkip.map(event => {
            return event.word
        })

        let matchingWords = knownWords.filter((word) => {
            let matchesCharacters = word.reading.match(orderedChars[0]);
            let recentlyUsed = readingsToSkip.includes(word.reading)
            return matchesCharacters && !recentlyUsed;
        });

        if (matchingWords.length < minWordOptions) {
            let additionalWords: WordEntry[] = knownWords.filter((word) => {
                return word.reading.match(orderedChars[1]) && !word.reading.match(orderedChars[0])
            });
            matchingWords = matchingWords.concat(additionalWords.slice(0, minWordOptions - matchingWords.length));
        } else {
            matchingWords = WordOracle.filterWords(matchingWords, orderedChars, minWordOptions)
        }


        return matchingWords
    }

    private static filterWords(
        matchingWords: WordEntry[],
        orderedChars: string[],
        minWordOptions: number): WordEntry[] {
        let wordsForRemoval: WordEntry[] = [];
        for (let i = 1; i < 2; i++) {
            for (let word of matchingWords) {
                if (!word.reading.match(orderedChars[i])) {
                    wordsForRemoval.push(word);
                    if (matchingWords.length - wordsForRemoval.length == minWordOptions) {
                        return matchingWords.filter((word) => {
                            return !wordsForRemoval.includes(word)
                        });
                    }
                }
            }
        }
        return matchingWords.filter((word) => {
            return !wordsForRemoval.includes(word)
        });
    }

    private static randomFrom(array: any[]): any {
        return array[(Math.floor(Math.random() * array.length))];
    }
}


// WEBPACK FOOTER //
// ./src/WordOracle.ts